enum Layout {
  LEADERBOARD = 'leaderboard',
  MEDIUM_RECTANGLE = 'medium-rectangle',
  WIDE_SKYSCRAPER = 'wide-skyscraper',
}

export { Layout };
